import 'css-chunksrc/client/scenes/task/allocations/allocation/allocatedHours/styles.scss';export default {
  "allocatedHours": "_allocatedHours_ixu7s_1",
  "edition": "_edition_ixu7s_7",
  "input": "_input_ixu7s_11",
  "text": "_text_ixu7s_31"
};